import React from 'react'
import { motion } from 'motion/react'
import { Flex } from 'mds-web-ui'
import { CardWrapper } from './ActionCard'

// backOut easing for a subtle pop as the card scales in
const backOut = [0.34, 1.56, 0.64, 1]

const MotionCardWrapper = motion.create(CardWrapper)

// The card keeps its natural (full) width and left-aligned position - matching a
// real action card - and only *scales* in from the centre. Using scale (a
// transform) rather than animating width means the layout box never changes, so
// the card lines up exactly with the real cards (no left/right offset or jump
// when the typed action becomes a real card) and the text never reflows.
const NewActionInner = React.forwardRef(({ color, bg, children }, ref) => (
  <Flex py="1px" ref={ref}>
    <MotionCardWrapper
      color={color}
      bg={bg}
      initial={{ scale: 0, opacity: 0 }}
      animate={{
        scale: 1,
        opacity: 1,
        transition: {
          scale: { duration: 0.2, ease: backOut },
          opacity: { duration: 0.15 },
          delayChildren: 0.1,
        },
      }}
      // hold the card's own values on exit; the linear scale-to-0 is applied by
      // the wrapper in ../NewAction
      exit={{ scale: 1, opacity: 1 }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.1 } }}
      >
        {children}
      </motion.div>
    </MotionCardWrapper>
  </Flex>
))

export const NewActionContainer = NewActionInner
